import lottie from "lottie-web";
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { applyBrandColors, PLANED_COLOR_MAP, computeResolvedVars } from '../../utils/lottieColorUtils';


const PlanAnimation = React.forwardRef((props, ref) => {
    const containerPlan = useRef(null);
    const primaryColor = useSelector(state => state['Settings']?.['currentBranding']?.['primaryColor']);
    const isCustomBranding = useSelector(state => state['Settings']?.['isCustomBranding']);
    const brandingLoaded = useSelector(state => state['Settings']?.['brandingLoaded']);

    useEffect(() => {
        if (!brandingLoaded) return;
        let animation;
        let cancelled = false;
        const resolvedVars = isCustomBranding ? computeResolvedVars(primaryColor) : {};
        fetch('/animation/planed.json')
            .then(r => r.json())
            .then(data => {
                if (cancelled || !containerPlan.current) return;
                containerPlan.current.innerHTML = ''; // remove any stale SVG so only the fresh brand-colored one renders
                animation = lottie.loadAnimation({
                    container: containerPlan.current,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    animationData: applyBrandColors(data, PLANED_COLOR_MAP, resolvedVars),
                });
            });
        return () => { cancelled = true; animation?.destroy(); };
    }, [primaryColor, brandingLoaded]);

    return (
        <div className="svg-animation-loader" ref={containerPlan} style={{ width: "400px", height: "400px", background: "transparent" }} />
    );
});

export default PlanAnimation;
